import React from 'react';
import { Card, CardContent, CardHeader, Typography, Box } from '@mui/material';
import { translate as t } from 'hooks/useTranslations';
import { neutral, primary } from '_lex/_foundations/phxColors';

export default function LexipolReportMetrics() {
  return (
    <Card className='lexipol-report-metrics lex-dashboard-card'>
      <CardHeader title={t('dashboard.lexipolReport.metrics.title')} />
      <CardContent>
        <Box sx={{ mt: 4 }}>
          <Typography
            variant='body1'
            sx={{ color: neutral[700] }}
          >
            {t('dashboard.lexipolReport.metrics.description')}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
}
